/* Copyright (c) 2021 Magnusson Institute, All Rights Reserved */

import React from "react"
import { Fab, Grid, Paper } from "@mui/material";
import WalletContext from "../contexts/WalletContext";
import DropZone from "../components/DropZone";
import BugReportIcon from "@mui/icons-material/BugReport";
import { red } from '@mui/material/colors';
import TokenExplorer from "../components/TokenExplorer";
import UnlockDialog from "../components/Modal/UnlockDialog";
import { useContext } from "react";
import AuthContext from "../contexts/AuthContext";
import FileBrowserContext from "../contexts/FileBrowserContext";
import DebugOverlay from "../components/Modal/DebugOverlay";
import * as __ from 'lib384/dist/384.esm'
import { sb_config } from "config";

const snackabra = new __.Snackabra(sb_config);

const fabRedStyle = {
  color: 'common.white',
  position: 'absolute',
  bottom: 16,
  right: 16,
  bgcolor: red[500],
  '&:hover': {
    bgcolor: red[600],
  },
};

const Home = () => {
  const auth = useContext(AuthContext)
  const wallet = React.useContext(WalletContext)
  const FileBrowser = React.useContext(FileBrowserContext)
  const [open, setOpen] = React.useState(false)
  const [controlMessages, setControlMessages] = React.useState<__.ChannelMessage[]>([])
  const [messages, setMessages] = React.useState<__.ChannelMessage[]>([])
  const [channel, setChannel] = React.useState<__.ChannelSocketTypeAlias>(undefined as unknown as __.ChannelSocketTypeAlias)

  React.useEffect(() => {
    if (wallet.id) {
      const loadWallet = async () => {
        console.log('wallet loaded')

        const c = await snackabra.connect(
          onMessage,
          wallet.identity.exportable_privateKey,
          wallet.id as string,
        );
        setChannel(c);
      }
      loadWallet();
    }
  }, [wallet.id])

  React.useEffect(() => {
    if(channel){
      channel.api.getOldMessages(0).then(async (messages: Array<any>) => {
        const _oldMessages = [];
        for (let x in messages) {
          const message = messages[x];

            _oldMessages.push({
              token: message.token,
              type: message.type,
              quantity: message?.quantity ? message.quantity : 1
            })

        }
        FileBrowser.setFiles(_oldMessages)
      });
    }
  }, [channel])

  const onMessage = async (msg: __.ChannelMessage) => {
    // let received = await window.Snackabra.channel.socket.receive(message)
    // const msg = JSON.parse(received);
    console.log(msg)
    if (msg.hasOwnProperty('verificationToken')) {
      setControlMessages([...controlMessages, msg])
    } else {
      setMessages([...messages, msg])
    }


  }

  const toggleDebugger = () => {
    setOpen(!open)
  }

  return (
    <Grid sx={{ pt: 12 }} container>
      <UnlockDialog open={auth.promptOpen} onClose={auth.promptCallback} />
      <Paper sx={{ width: '100%' }}>
        <DropZone messages={messages} />
        <DebugOverlay open={open} onClose={toggleDebugger} />
      </Paper>
      {wallet.id ?
        <Paper sx={{ width: '100%', mt: 4 }}>
          <TokenExplorer />
        </Paper>
        : ''

      }
      <Fab onClick={toggleDebugger} sx={{ ...fabRedStyle }}>
        <BugReportIcon />
      </Fab>
    </Grid>
  )
}

export default Home;


